(function () {
  // Remove bloqueio de renderização se o usuário prefere movimento reduzido
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.getElementById('view-transition-render-blocker')?.remove();
  }

  const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

  window.addEventListener('pageswap', (event) => {
    if (!event.viewTransition) return;

    // Melhora INP: Cancela transição se houver interação do usuário
    const skip = () => event.viewTransition.skipTransition();
    ['pointerdown', 'keydown'].forEach(evt => document.addEventListener(evt, skip, { once: true }));

    // Limpeza de atributos para evitar duplicidade
    document.querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach(el => el.removeAttribute('data-view-transition-type'));

    const triggered = document.querySelector('[data-view-transition-triggered]');
    const type = triggered?.getAttribute('data-view-transition-type');
    const types = event.viewTransition.types;

    types.clear();
    if (type) {
      types.add(type);
      sessionStorage.setItem('custom-transition-type', type);
    } else {
      types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    if (!event.viewTransition) return;

    const types = event.viewTransition.types;
    const customType = sessionStorage.getItem('custom-transition-type');

    types.clear();
    
    if (customType) {
      types.add(customType);
      await event.viewTransition.finished;
      
      // Reseta para navegação padrão após o fim da animação
      types.clear();
      types.add('page-navigation');

      runIdle(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]')
          .forEach(el => el.removeAttribute('data-view-transition-type'));
      });
    } else {
      types.add('page-navigation');
    }
  });
})();